import { TravelTypeModeEnum } from './travel-type-container/travel-type-container.enum'
import { TravelTypeEnum } from '../../../lib/graphql'

export const getTravelTypeClassNameByEnum = (
  travelTypeModeEnum: TravelTypeModeEnum,
): string => {
  switch (travelTypeModeEnum) {
    case TravelTypeModeEnum.HOUSE_SEARCH:
      return 'houseSearch'
    default:
      return 'default'
  }
}

export const getBudgetTravelTypeFromTravelType = (
  travelType: TravelTypeEnum,
) => {
  switch (travelType) {
    case TravelTypeEnum.DAILY_TRIP:
      return 'dailyTrip'
    case TravelTypeEnum.NIGHTLY_TRIP:
      return 'nightlyTrip'
    case TravelTypeEnum.CORPORATE_EVENING_EVENT:
      return 'corporateEveningEvent'
    default:
      return undefined
  }
}
